/**
 * Guide engine v3 overlay - element rect tracking (#1025, epic #1020). Spec R15.
 *
 * A ring tracks its target element on scroll / resize (re-measures) while the
 * popup stays fixed at its placement coords (decoupled, R1.6). The element can
 * also move without a scroll/resize (a layout shift, an async row mount), so a
 * low-frequency interval re-measures as a backstop. Returns null when the element
 * is not in the DOM.
 */

import { useEffect, useState } from 'react';

const REMEASURE_MS = 250;

export const useElementRect = (selector, { active = true } = {}) => {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    if (!active || !selector || typeof document === 'undefined') {
      setRect(null);
      return undefined;
    }
    const measure = () => {
      const el = document.querySelector(selector);
      setRect(el ? el.getBoundingClientRect() : null);
    };
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);
    const timer = setInterval(measure, REMEASURE_MS);
    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
      clearInterval(timer);
    };
  }, [selector, active]);

  return rect;
};
